import { App } from 'vue';
import * as components from './components/index';
import { setVueInstance } from './utils/config/index';
import { Defaults, setupDefaults } from './utils/defaults';
import './styles/index.css';

const install = (app: App, defaults: Defaults = {}) => {
  setVueInstance(app);
  app.use(setupDefaults, defaults);
  const prefix = app.config.globalProperties.$VCalendar.componentPrefix;
  for (const componentKey in components) {
    const component = (components as any)[componentKey];
    app.component(`${prefix}${component.name}`, component);
  }
};

export default { install };
export * from './components';
export { setupDefaults as setupCalendar } from './utils/defaults';
export { popoverDirective } from './utils/popovers';

export { createCalendar, useCalendar } from './use/calendar';
export { createDatePicker, useDatePicker } from './use/datePicker';
